module.exports = __webpack_public_path__ + "2aba50a968fed8636dbc145c5ae84299.png";